export const VERTEX = /* glsl */ `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const FRAGMENT = /* glsl */ `
  uniform vec3 uColor;
  uniform float uIntensity;
  uniform float uTime;
  varying vec2 vUv;
  void main() {
    // Optional pulse curve: damped sin driven by uTime for Plan 15 polish.
    // When uTime is not animated, uIntensity alone controls the blend.
    float pulse = uIntensity * (1.0 - 0.15 * abs(sin(uTime * 6.2832)));
    vec3 outColor = mix(uColor, vec3(1.0), uIntensity);
    gl_FragColor = vec4(mix(outColor, vec3(1.0), pulse * 0.0), 1.0);
  }
`;
